/*
 * Checks if URL Mappings list contains mapping for a given key
 */
export var isMappingExists = function (urlMappings, key) {
    return urlMappings.some(function (urlMapping) { return urlMapping.key === key; });
};
//# sourceMappingURL=is-mapping-exists.js.map